// 各类会员权益枚举
export const ENUM_MEMBER_BENEFIT = {
	// 高级查询
	GJCX_FILER: 'GJCX_FILER',
	// 人员、企业画像
	RY_QY_HX: 'RY_QY_HX',
	// 人员分析
	RYFX: 'RYFX',
	// 基本信息
	JBXX: 'JBXX',
	// 基本信息详情
	JBXX_XQ: 'JBXX_XQ',
	// 报告导出
	BGDC: 'BGDC',
	// 证书记录
	ZSJL: 'ZSJL',
	// 证书查看
	ZSCK: 'ZSCK',
	// 监控其他企业/人员
	JK_QT_QY_RY: 'JK_QT_QY_RY',
	// 本企业监控/人员
	JK_QY_RY: 'JK_QY_RY',
	// 自定义监控
	ZDYJK: 'ZDYJK',
	// 自定义监控设置
	ZDYJK_SET: 'ZDYJK_SET',
	// 资质预警
	ZZYJ: 'ZZYJ',
	// 自定义资质预警
	ZDYZZYJ: 'ZDYZZYJ',
	// 资质诊断
	ZZZD: 'ZZZD',
	// 诊断报告下载
	ZDBGXZ: 'ZDBGXZ',
	// 高级筛选
	GJSX_FILER: 'GJSX_FILER',
	// 下载简历
	XZJL: 'XZJL',
	// 人员对比分析
	RYDBFX: 'RYDBFX',
	// 人员分析
	ZPQZ_RYFX: 'ZPQZ_RYFX',
	// 资质背调
	ZZBD: 'ZZBD',
	// 职位发布
	ZWFB: 'ZWFB',
	// 查看关注人员
	CKGZRY: 'CKGZRY',
	// 下载接收简历
	XZJSJL: 'XZJSJL',
	// 人才推介
	RCTJ: 'RCTJ',
	// 招聘置顶
	ZPZD: 'ZPZD',
	// 企业、岗位广告位占领
	QY_GW_GGW: 'QY_GW_GGW',
	// 联系人才
	LXRC: 'LXRC',
	// 索要联系方式
	SYLXFS: 'SYLXFS'
}
